export default "__VITE_ASSET__BEDOCkdM__"